import { Response } from '../../utils/interfaces/response';
import { PeriodoDTO } from '../../utils/models';
import http from '../http/http';

export class ValidateCertificateService {
  validateCertificate(token: string) {
    return http.get<Response<PeriodoDTO>>(`/Valida/${token}`);
  }
}
